import 'bootstrap';

import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";

import '../styles/main.scss';

import background from '../assets/imgs/fundo.jpg'
document.body.style.backgroundImage = `url("${background}")`;

console.log('index.js')

